/*
 * <careers-form> — storefront job application.
 *
 * Flow: ask the app for a signed staged upload target, POST the CV straight to Shopify,
 * then submit the applicant's details plus the signed resourceUrl. No user-facing strings
 * live here; messages are looked up by code in `[data-careers-messages]`.
 */
(function () {
  if (customElements.get('careers-form')) return;

  var MAX_BYTES = 10 * 1024 * 1024;

  class CareersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-careers-form]');
      this.status = this.querySelector('[data-careers-status]');
      this.button = this.querySelector('[data-careers-submit]') || this.form.querySelector('[type="submit"]');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });
    }

    message(code) {
      var el = this.querySelector('[data-careers-messages] [data-code="' + code + '"]') ||
        this.querySelector('[data-careers-messages] [data-code="generic"]');
      return el ? el.textContent : '';
    }

    show(code, tone) {
      this.status.hidden = false;
      this.status.dataset.tone = tone || 'info';
      this.status.textContent = this.message(code);
    }

    async post(url, payload) {
      try {
        var response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        var body = await response.json().catch(function () { return {}; });
        return [response.ok, body];
      } catch (e) {
        return [false, {}];
      }
    }

    async submit() {
      if (this.busy) return;

      var data = new FormData(this.form);
      var file = data.get('cv');
      var name = String(data.get('name') || '').trim();
      var email = String(data.get('email') || '').trim();

      if (!name) return this.show('name_required', 'error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.show('invalid_email', 'error');
      if (!file || !file.size) return this.show('missing_cv', 'error');
      if (file.size > MAX_BYTES) return this.show('cv_too_large', 'error');

      this.busy = true;
      if (this.button) this.button.disabled = true;

      try {
        this.show('uploading');
        var [stagedOk, target] = await this.post(this.dataset.uploadUrl, {
          file: { filename: file.name, mimeType: file.type, fileSize: file.size },
        });
        if (!stagedOk) return this.show(target.error || 'generic', 'error');

        // Shopify's parameters first and in order; no Content-Type so the browser sets the boundary.
        var upload = new FormData();
        (target.parameters || []).forEach(function (p) { upload.append(p.name, p.value); });
        upload.append('file', file);
        var uploaded = await fetch(target.url, { method: 'POST', body: upload })
          .then(function (r) { return r.ok; })
          .catch(function () { return false; });
        if (!uploaded) return this.show('generic', 'error');

        this.show('sending');
        var [ok, body] = await this.post(this.dataset.submitUrl, {
          name: name,
          email: email,
          phone: String(data.get('phone') || ''),
          position: String(data.get('position') || ''),
          message: String(data.get('message') || ''),
          cvFilename: file.name,
          resourceUrl: target.resourceUrl,
          token: target.token,
        });
        if (!ok) return this.show(body.error || 'generic', 'error');

        this.form.hidden = true;
        var success = this.querySelector('[data-careers-success]');
        success.hidden = false;
        success.focus();
      } finally {
        this.busy = false;
        if (this.button) this.button.disabled = false;
      }
    }
  }

  customElements.define('careers-form', CareersForm);
})();
